import danaiTeam from "../assets/img/danai-team.png";
import warningIcon from "../assets/img/icon/warning.png";

import {Accordion, AccordionTab} from 'primereact/accordion';

import Milestone from './Components/MilestoneSection'
import PromoSlider from './Components/Promo/PromoSlider'


import React, {useEffect} from "react";

import DownloadAppSection from "./Components/DownloadAppSection";
import MengapaDanaiSection from "./Components/MengapaDanaiSection";
import PartnerKamiSection from "./Components/PartnerKamiSection";
import {useLocation} from "react-router-dom";
import WarningDialog from "./Components/WarningDialog";
import HeroSection from "./Components/HeroSection";
import StatistikDanai from "./Components/StatistikDanai";

function LandingPage() {
    // function untuk refreh page LandingPage setiap buka page tersebut
    useEffect(() => {
        const reloadCount = sessionStorage.getItem('reloadCount');
        if (reloadCount < 1) {
            sessionStorage.setItem('reloadCount', String(reloadCount + 1));
            window.location.reload();
        } else {
            sessionStorage.removeItem('reloadCount');
        }
    }, []);
    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const element = document.querySelector(location.hash);
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
            }
        }
    }, [location]);

    return (
        <>
            <div className="header-height"/>
            <nav className="nav-warning" id="nav-message">
                <div className="message-warning">
                    <span className="info"><img src={warningIcon} alt=""/></span>
                    <p>
                        <span>
                        <span className="yellow-bg">
                            <strong>Danai.id</strong> tidak pernah meminta sejumlah uang atau deposit kepada calon Peminjam
                        </span>
                    sebagai syarat untuk memproses pengajuan pinjaman.<br className="br-landing"/>
                        <span
                            className="warning-mobile">Jika Anda membutuhkan bantuan, hubungi kami di <strong>021 - 5010 3363</strong> atau <strong>customer.care@danai.id</strong></span></span>
                    </p>
                </div>
            </nav>
            {/* BANNER / HERO SECTION */}
            <HeroSection/>
            {/*WARNING POPUP*/}
            <WarningDialog/>

            {/* MENGAPA DANAI PILIHAN TERBAIK */}
            <MengapaDanaiSection/>

            {/* STATISTIK DANAI */}
            <StatistikDanai/>

            {/* MILESTONE  */}
            <Milestone/>

            {/* SNIPPET TEAM */}
            <div className="container-4">
                <div className="backBox">
                    <div className="teamContainer">
                        <img src={danaiTeam} alt='danai team'/>
                        <div className="teamtext">
                            <h3>Keahlian tim kami didukung oleh para <b>profesional perbankan</b> dengan pengalaman <b>puluhan
                                tahun</b> sebagai <b>top manajemen.</b></h3>
                            <a href="/tentang-kami" className="btn-danai blue-outline">Lihat Selengkapnya</a>
                        </div>
                    </div>
                </div>
            </div>
            {/* SNIPPET TEAM ENDS */}

            {/* PRODUCT DANAI */}
            <div className="container-5" id='product-section'>
                <div className="section-title text-center">
                    <h2 className="text-header">Temukan Solusi Keuangan yang Cepat & Tepat di <span>Danai.id</span></h2>
                    <p>Telusuri lebih lagi tentang beragam pilihan pinjaman yang ditawarkan sebagai solusi, baik untuk
                        keperluan individu maupun keperluan produktif usaha Anda.</p>
                </div>
                <div className="product-container">
                    <div className="cardProduct">
                        <div className="productiveImg"></div>
                        <div className="contentBlue">
                            <div className="topSection">
                                <h3 className="titleBlue">Pinjaman Usaha</h3>
                                <p>Dapatkan dana yang Anda butuhkan untuk memperluas usaha, meningkatkan produksi, atau
                                    mengembangkan ide bisnis Anda.</p>
                            </div>
                            <div className="listProduct">
                                <Accordion multiple activeIndex={[0]}>
                                    <AccordionTab header="Invoice Financing">
                                        <p>Fasilitas pinjaman yang diberikan kepada Pelaku Usaha yang memerlukan
                                            pembiayaan pada saat menunggu proses pembayaran dari Pemberi
                                            Kerja <em>(Bowheer)</em> dan/atau Pembeli <em>(Buyer)</em> dengan
                                            menggunakan jaminan <em>invoice.</em></p>
                                        <a href="/invoice-financing">Pelajari</a>
                                    </AccordionTab>
                                    <AccordionTab header="Inventory Financing">
                                        <p>Fasilitas pinjaman yang diberikan kepada Pelaku Usaha dengan menggunakan
                                            barang persediaan sebagai jaminan.</p>
                                        <a href="/inventory-financing">Pelajari</a>
                                    </AccordionTab>
                                    {/*<AccordionTab header="Investment Financing">*/}
                                    {/*    <p>Fasilitas pinjaman produktif untuk membeli barang sebagai investasi.</p>*/}
                                    {/*    <a href="/kredit-modal-usaha">Pelajari</a>*/}
                                    {/*</AccordionTab>*/}
                                    <AccordionTab header="Developer Financing">
                                        <p>Fasilitas pinjaman yang diberikan kepada Pelaku Usaha (Developer) dimana
                                            penggunaannya diperuntukkan sebagai modal pembangunan perumahan dengan skema
                                            pembayaran yang fleksibel.</p>
                                        <a href="/developer-financing">Pelajari</a>
                                    </AccordionTab>

                                </Accordion>
                            </div>
                        </div>
                    </div>

                    <div className="cardProduct">
                        <div className="consumptiveImg">

                        </div>
                        <div className="contentGreen">
                            <div className="topSection">
                                <h3 className="titleGreen">Pinjaman Individu</h3>
                                <p>Dapatkan dana cepat dan mudah untuk memenuhi kebutuhan Anda, mulai dari pendidikan,
                                    kesehatan, dan lainnya.</p>
                            </div>
                            <div className="listProduct pb-2">
                                <Accordion multiple activeIndex={[0]}>
                                    <AccordionTab header="Pinjaman Karyawan">
                                        <p> Fasilitas pinjaman tanpa agunan untuk berbagai macam kebutuhan. Jangka waktu
                                            pinjaman hingga 2 tahun dan pembayaran angsuran dilakukan setiap bulan.
                                        </p>
                                        <a href="/pinjaman-karyawan">Pelajari</a>
                                    </AccordionTab>
                                    <AccordionTab header="Kasbon / Emergency Loan">
                                        <p>Fasilitas pinjaman untuk kebutuhan darurat yang memberi kemudahan bagi
                                            karyawan seperti pembayaran gaji di muka <em>(Salary Advance).</em></p>
                                        <a href="/kasbon">Pelajari</a>
                                    </AccordionTab>
                                    {/*<AccordionTab header="Kredit Pembelian Barang">*/}
                                    {/*    <p>Fasilitas pinjaman untuk membantu karyawan membeli barang untuk mendukung*/}
                                    {/*        pekerjaan.</p>*/}
                                    {/*    <a href="/pinjaman-karyawan">Pelajari</a>*/}
                                    {/*</AccordionTab>*/}
                                    {/*<AccordionTab header="Kredit Kendaraan Bermotor">*/}
                                    {/*    <p>Fasilitas Kredit Kendaraan Bermotor baik kepemilikan pribadi Karyawan atau Perusahaan (COP).</p>*/}
                                    {/*    <a href="/pinjaman-karyawan">Pelajari</a>*/}
                                    {/*</AccordionTab>*/}
                                    <AccordionTab header="Kredit Multiguna">
                                        <p>Kredit yang ditujukan untuk keperluan berbagai kebutuhan dari renovasi rumah
                                            sampai <em>refinancing,</em> dengan jaminan berupa tanah dan bangunan.</p>
                                        <a href="/kmg">Pelajari</a>
                                    </AccordionTab>
                                    {/*<AccordionTab header="Kredit Tanpa Agunan">*/}
                                    {/*    <p>Fasilitas pinjaman tanpa agunan dengan syarat mudah.</p>*/}
                                    {/*    <a href="/pinjaman-karyawan">Pelajari</a>*/}
                                    {/*</AccordionTab>*/}
                                </Accordion>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* PRODUCT DANAI ENDS */}

            {/* DOWNLOAD */}
            <DownloadAppSection/>

            {/* PARTNER KAMI */}
            <PartnerKamiSection/>

            {/* PROMO BANNER SLIDER  */}
            <PromoSlider/>
        </>
    );
}

export default LandingPage;